"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const IS_1 = __importDefault(require("./IS"));
const STR_1 = __importDefault(require("./STR"));
class OBJ {
    constructor(obj) {
        this.inner = (key) => ({
            //? inner set
            set: (value) => {
                let curObj = this.obj;
                const keys = IS_1.default.string(key) ? [...key === null || key === void 0 ? void 0 : key.split('.')] : key;
                for (let i = 0; i < keys.length; i++) {
                    const cur = keys === null || keys === void 0 ? void 0 : keys[i];
                    const isLast = i === (keys === null || keys === void 0 ? void 0 : keys.length) - 1;
                    if ((curObj === null || curObj === void 0 ? void 0 : curObj[cur]) === undefined)
                        curObj[cur] = {};
                    if (isLast) {
                        if (IS_1.default.function(value))
                            curObj[cur] = value === null || value === void 0 ? void 0 : value(curObj === null || curObj === void 0 ? void 0 : curObj[cur]);
                        else
                            curObj[cur] = value;
                    }
                    curObj = curObj === null || curObj === void 0 ? void 0 : curObj[cur];
                }
                return this.obj;
            },
            //? inner get
            get: () => {
                let curObj = this.obj;
                const keys = IS_1.default.string(key) ? [...key === null || key === void 0 ? void 0 : key.split('.')] : key;
                for (let i = 0; i < keys.length; i++) {
                    curObj = curObj === null || curObj === void 0 ? void 0 : curObj[keys === null || keys === void 0 ? void 0 : keys[i]];
                    const isLast = i === (keys === null || keys === void 0 ? void 0 : keys.length) - 1;
                    if (curObj === undefined || isLast)
                        return curObj;
                }
            },
        });
        this.obj = OBJ.clone(obj);
    }
}
exports.default = OBJ;
_a = OBJ;
//? ---------------------- Static methods --------------------------------------------------------
OBJ.is_empty = (obj) => Object.keys(obj || {}).length === 0;
OBJ.clone = (object) => JSON.parse(JSON.stringify(object || {}));
OBJ.equals = (...objects) => {
    const first = STR_1.default.sort(JSON.stringify(objects[0]));
    return objects.every((obj, i) => i === 0 || STR_1.default.sort(JSON.stringify(obj)) === first);
};
OBJ.diff = (oldObj, newObj) => {
    const diff = {};
    const entries = Object.entries(newObj || {});
    entries === null || entries === void 0 ? void 0 : entries.forEach(([key, value]) => {
        const isBothArr = IS_1.default.array(oldObj[key]) && IS_1.default.array(value);
        const isBothObj = IS_1.default.object(oldObj[key]) && IS_1.default.object(value);
        if (isBothObj || isBothArr) {
            if (_a.equals(oldObj[key], value))
                return;
            diff[key] = _a.diff(oldObj === null || oldObj === void 0 ? void 0 : oldObj[key], value);
            return;
        }
        if ((oldObj === null || oldObj === void 0 ? void 0 : oldObj[key]) === value)
            return;
        diff[key] = value;
    });
    return diff;
};
